import { all, put, takeEvery } from "@redux-saga/core/effects";
import { setErrorStatus } from "../status/actions";
import { addRegData } from "../../services/database";
import store from "../store/store";

export const intentActionTypes = {
  PUT_REGISTRATION_DATA: "PUT_REGISTRATION_DATA",
  ADD_REGISTRATION_DATA: "ADD_REGISTRATION_DATA"
};

function* putRegistrationData(action) {
  try {
    yield setIntentLoading(true);
    const { regToken, device, deviceId } = action.payload.dat;
    yield put({
      type: "SET_REG_DATA",
      payload: {
        regToken,
        device,
        deviceId
      }
    });

    action.payload.navigate("/", { replace: true });

    yield setIntentLoading(false);
  } catch (error) {
    yield setIntentLoading(false);
    setErrorStatus(error);
  }
}

function* addRegistrationData(action) {
  try {
    yield setIntentLoading(true);

    const { intent, auth } = store.getState();

    yield addRegData(intent.data.deviceId, {
      registrationToken: intent.data.regToken,
      lastLogin: +new Date(),
      osVersion: intent.data.device.toString(),
      phoneNumber: auth.data.phoneNumber,
      type: "test",
      userTypes: ["patients"]
    });

    yield setIntentLoading(false);
  } catch (error) {
    yield setIntentLoading(false);
    setErrorStatus(error);
  }
}

export default function* intentsWatcher() {
  yield all([
    takeEvery("PUT_REGISTRATION_DATA", putRegistrationData),
    takeEvery("ADD_REGISTRATION_DATA", addRegistrationData)
  ]);
}

function* setIntentLoading(bool) {
  yield put({
    type: "SET_INTENT_LOADING",
    payload: {
      loading: bool
    }
  });
}
